import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl, intlShape } from 'react-intl'
import Helmet from 'react-helmet';

import Loader from '../components/Loader'

import FullbleedHero from '../components/ContentBlocks/FullbleedHero'
import ContentBlockImage from '../components/ContentBlocks/ContentBlockImage'
import ContentBlockHolder from '../components/ContentBlocks/ContentBlockHolder'
import ContentBlock from '../components/ContentBlocks/ContentBlock'
import FullbleedContentBlock from '../components/ContentBlocks/FullbleedContentBlock'

import OfferForm from '../components/OfferForm'
import CompanyCardForm from '../components/CompanyCardForm'
import ShopifyProduct from '../components/Shopify/ShopifyProduct'

// import Jobs from '../components/Jobs'

import { fetchPage, fetchCollection, fetchJobs, fetchJobContainers } from '../redux/actions'

class ContentPage extends Component {
  componentDidMount() {
    this.checkForPageData();
  }

  componentDidUpdate() {
    this.checkForPageData();
  }

  checkForPageData() {
    const locale = this.props.intl.locale;
    const slug = this.props.match.params.slug;
    const page = this.props.pages[slug];
    const collection = this.props.collection;
    // const jobs = this.props.jobs;

    if (!page) {
      this.props.fetchPage(slug, locale)
    }

    if(page) {
      if(page.elements) {
        if (!collection && page.elements.filter(e => e.sys.contentType.sys.id==='shopifyCollection').length > 0) {
          const collectionId = page.elements.find((e) => {
            return e.sys.contentType.sys.id==='shopifyCollection'
          }).fields.collectionId;

          this.props.fetchCollection(collectionId);
        }
        // if (page.elements.filter(e => e.fields.heading==='jobs').length > 0 && jobs.length === 0) {
        //   this.props.fetchJobs();
        // }
      }
    }
  }

  render() {
    const slug = this.props.match.params.slug
    const {pages} = {...this.props}

    const page = pages[slug]

    const collection = this.props.collection

    // const jobs = this.props.jobs

    return (
      <div className={slug}>
        {!pages[slug] && <Loader/>}
        {pages[slug] &&
          <div>
            <Helmet>
              <title>{page.title}</title>
            </Helmet>
            {page.elements &&
              page.elements.map((key, i) => {
                if (key.sys.contentType.sys.id==='header') {
                  return (
                    <FullbleedHero key={key.sys.id} fields={key.fields} />
                  )
                }

                if(key.sys.contentType.sys.id==='container') {
                  // if(key.fields.heading==='jobs') {
                  //   return(
                  //     <Jobs jobs={jobs} key={key.sys.id} />
                  //   )
                  // }
                  // else {
                    if(key.fields.type===true) {
                      const align = key.fields.align.toLowerCase()

                      if((align==='left'||align==='right') && key.fields.image) {
                        return (
                          <ContentBlockImage align={align} fields={key.fields} key={key.sys.id} />
                        )
                      }

                      if(align==='dual') {
                        return (
                          <ContentBlockHolder dual key={key.sys.id}>
                            {key.fields.elements.map((key, i) => {
                              return (
                                <ContentBlock key={key.sys.id} align={key.fields.align.toLowerCase()} fields={key.fields} />
                              )
                            })}
                          </ContentBlockHolder>
                        )
                      }

                      if(align==='triple') {
                        return (
                          <ContentBlockHolder triple key={key.sys.id}>
                            {key.fields.elements.map((key, i) => {
                              return (
                                <ContentBlock key={key.sys.id} align="triple" fields={key.fields} />
                              )
                            })}
                          </ContentBlockHolder>
                        )
                      }

                      return (
                        <ContentBlockHolder key={key.sys.id}>
                          <ContentBlock align={align} fields={key.fields} />
                        </ContentBlockHolder>
                      )
                    }
                    if(key.fields.type===false) {
                      return (
                        <FullbleedContentBlock key={key.sys.id} align={key.fields.align.toLowerCase()} fields={key.fields} />
                      )
                    }
                  // }
                }
                if (key.sys.contentType.sys.id==='jobOpenings') {
                  if (!key.fields || !key.fields.jobs) return null;
                  return (
                    <ContentBlockHolder triple key={key.sys.id}>
                      {key.fields.jobs.map((key, i) => (
                        <ContentBlock key={key.sys.id} align="triple" job fields={key.fields} />
                      ))}
                    </ContentBlockHolder>
                  )
                }
                if (key.sys.contentType.sys.id==='shopifyCollection') {
                  return (
                    <div key={key.sys.id} className={`shopify-collection ${collection && collection.length > 1 ? 'multiple' : 'single'}`}>
                      {collection && collection.map((key, i) => {
                        return (
                          <ShopifyProduct key={key.id} product={key} {...this.props} />
                        )
                      })}
                    </div>
                  )
                }
                return null;
              })
            }

            {page.slug === 'premium-catering' &&
              <OfferForm />
            }
            {page.slug === 'Yritysasiakkuus' &&
              <CompanyCardForm />
            }
          </div>
        }
      </div>
    );
  }
}

ContentPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  pages: state.pages,
  collection: state.collections,
  jobs: state.jobs,
  jobContainer: state.jobContainers
})

const mapDispatchToProps = {
  fetchPage,
  fetchCollection,
  fetchJobs,
  fetchJobContainers
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ContentPage))



// WEBPACK FOOTER //
// ./src/containers/ContentPage.js